module.exports = ".image-effect-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .image-effect-form mat-form-field {\n    width: calc(100% - 140px);\n    margin-left: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-image-effect-form/product-image-effect-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-image-effect-form/product-image-effect-form.component.scss
// module chunks = main